export default __webpack_public_path__ + "static/media/alert.e5cc061a.svg";